import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MailCheck, ArrowLeft } from "lucide-react";
import { api } from "../../../lib/api";
import { apiErr } from "../../../lib/apiErr";
import { AuthShell, AUTH_INPUT, AUTH_LABEL } from "./AuthShell";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [state, setState] = useState(null);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setState(null);
    try {
      const r = await api.post("/auth/forgot-password", { email: email.trim(), app_url: window.location.origin });
      setState(r.data.mail_sent === false ? { err: "Email gagal dikirim. Coba lagi nanti." } : { ok: true });
    } catch (err) { setState({ err: apiErr(err, "Gagal meminta tautan reset") }); } finally { setBusy(false); }
  };
  return (
    <AuthShell onSubmit={submit} subtitle="Lupa password" testid="forgot-page">
      {state?.ok ? (
        <div className="mt-7 rounded-2xl bg-emerald-500/10 p-4 text-sm text-emerald-200" data-testid="forgot-sent">
          <MailCheck size={18} className="mb-2 text-emerald-300" />
          Jika <b>{email}</b> terdaftar sebagai akun aktif, tautan reset sudah dikirim. Tautan berlaku 60 menit dan hanya bisa dipakai sekali.
        </div>
      ) : (
        <>
          <p className="mt-6 text-xs text-white/60">Masukkan email staf Anda. Kami akan mengirim tautan untuk membuat password baru.</p>
          <label className={AUTH_LABEL}>Email staf<input className={AUTH_INPUT} type="email" required autoFocus placeholder="nama@oryntix.com" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="username" data-testid="forgot-email" /></label>
          {state?.err && <p className="mt-3 rounded-xl bg-rose-500/10 px-3 py-2 text-xs text-rose-200" data-testid="forgot-error">{state.err}</p>}
          <button disabled={busy} className="btn-grad mt-6 w-full rounded-xl py-2.5 text-sm" data-testid="forgot-submit">{busy ? <Loader2 size={14} className="mx-auto animate-spin" /> : "Kirim tautan reset"}</button>
        </>
      )}
      <Link to="/" className="mt-5 inline-flex items-center gap-1.5 text-xs font-semibold text-white/60 hover:text-white" data-testid="forgot-back"><ArrowLeft size={13} /> Kembali ke login</Link>
    </AuthShell>
  );
}
